/**
 * Router - React Router routes for the embedded admin app.
 *
 * Pages are lazy-loaded: each route's code only downloads on navigation
 * instead of upfront in the main bundle.
 */
import { Box, Spinner } from '@nimbus-ds/components';
import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const CatalogPage = lazy(() =>
  import('@/pages/catalog-page').then((m) => ({ default: m.CatalogPage })),
);
const EnhancePage = lazy(() =>
  import('@/pages/enhance-page').then((m) => ({ default: m.EnhancePage })),
);
const ErrorPage = lazy(() =>
  import('@/pages/error-page').then((m) => ({ default: m.ErrorPage })),
);
const ProgressPage = lazy(() =>
  import('@/pages/progress-page').then((m) => ({ default: m.ProgressPage })),
);
const ReviewPage = lazy(() =>
  import('@/pages/review-page').then((m) => ({ default: m.ReviewPage })),
);
const SettingsPage = lazy(() =>
  import('@/pages/settings-page').then((m) => ({ default: m.SettingsPage })),
);

function RouteFallback() {
  return (
    <Box
      alignItems="center"
      display="flex"
      height="100vh"
      justifyContent="center"
    >
      <Spinner size="large" />
    </Box>
  );
}

export function Router() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<CatalogPage />} path="/" />
        <Route element={<EnhancePage />} path="/products/:productId/enhance" />
        <Route
          element={<ProgressPage />}
          path="/products/:productId/progress"
        />
        <Route element={<ReviewPage />} path="/products/:productId/review" />
        <Route element={<SettingsPage />} path="/settings" />
        <Route element={<ErrorPage />} path="/error" />
        <Route element={<Navigate replace to="/" />} path="*" />
      </Routes>
    </Suspense>
  );
}
